import {
  TableRow,
  TableCell,
  Typography,
  Chip,
  Box,
  Stack,
} from '@mui/material';
import { Link } from 'react-router';
import { Api } from '../../api';
import { Model } from '../../models';
import { format } from 'date-fns';

type Props = {
  client: Api.User.V_ClientList;
};

export default function ClientsRow({ client }: Props) {
  const week =
    client.programProgress?.currentWeekNumber != null
      ? `${client.programProgress.currentWeekNumber} Week`
      : undefined;

  const subscription = Model.User.getSubscriptionStatusLabel(
    client.subscriptionInfo,
  );
  const { team, organisation } = Model.User.getTeamAndOrganisation(
    client.subscriptionInfo,
  );

  return (
    <TableRow
      component={Link}
      to={`/users/${client.user.id}/user-dashboard`}
      sx={{
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <TableCell>
        <Typography variant="body2" fontWeight={500}>
          {client.user.name ?? '-'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" color="textSecondary">
          {client.user.email}
        </Typography>
      </TableCell>
      <TableCell>
        <Box display="flex" alignItems="center" gap={1}>
          <Chip
            label={Model.ProgramProgress.getStatusLabel(client.programProgress)}
            color={Model.ProgramProgress.getStatusColor(client.programProgress)}
          />
          {week && (
            <Typography variant="body2" color="textSecondary">
              {week}
            </Typography>
          )}
        </Box>
      </TableCell>
      <TableCell>
        <Box>
          <Typography variant="body2">
            {client.appointmentHeld ?? 0} held
          </Typography>
          <Typography variant="body2">
            {client.appointmentScheduled ?? 0} scheduled
          </Typography>
        </Box>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {format(client.user.registeredAt, 'd MMM yyyy')}
        </Typography>
      </TableCell>
      <TableCell>
        <Stack gap={1} alignItems="flex-start">
          {client.user.classifications.map((classification) => (
            <Chip
              key={classification.id}
              label={classification.name}
              color="default"
              size="small"
            />
          ))}
        </Stack>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{subscription}</Typography>
      </TableCell>
      <TableCell>
        {organisation || team ? (
          <Box>
            {organisation && (
              <Typography variant="body2">{organisation.name}</Typography>
            )}
            {team && (
              <Typography variant="body2" color="textSecondary">
                {team.name}
              </Typography>
            )}
          </Box>
        ) : (
          <Typography variant="body2">-</Typography>
        )}
      </TableCell>
    </TableRow>
  );
}
